import { createSelector } from 'reselect'


export default createSelector(
  state => state.data.__activities__,
  (state, entityIdentifier) => entityIdentifier,
  (activities, entityIdentifier) =>
    activities && activities.find(activity =>
      activity.entityIdentifier === entityIdentifier && activity.patch.photo))
